var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('TableList',_vm._b({on:{"on-radio-change":_vm.checkChange}},'TableList',_vm.getData,false)),_c('div',{staticClass:"text-right"},[_c('vButton',{attrs:{"theme":"primary"},on:{"click":_vm.click}},[_vm._v("确定")]),_c('vButton',{staticClass:"margin-left-10",on:{"click":_vm.cancel}},[_vm._v("取消")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }